import React from 'react'
import {SimpleBanner} from './banner'

export default class PageNotFound extends React.Component {
	render() {
		return (
			<div>
				<SimpleBanner />
				<div className="container">
					<div className="row mt-4">
						<div className="col">
							<h5>
								{__('errors_page_not_exists')}
							</h5>
							<div dangerouslySetInnerHTML={{__html: __('errors_page_not_found')}} />
							<ul className="list-group">
								<li className="list-group-item">{__('errors_page_offline_by_admin')}</li>
								<li className="list-group-item">{__('errors_page_requires_authentication')}</li>
								<li className="list-group-item">{__('errors_page_website_missconfiguration')}</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

